module.exports = {
  HIERARCHY: 'hierarchy',
  GEO: 'geo',
  HEX: 'hex',
  GRAPH: 'graph',
  TABLE: 'table',
  GEO_GRATICULE: 'geo-graticule',
  STATISTICS_METHODS: ['max', 'mean', // alias: average
  'median', 'min', 'mode', 'product', 'standardDeviation', 'sum', 'sumSimple', 'variance']
};


//////////////////
// WEBPACK FOOTER
// ./src/constants.js
// module id = 83
// module chunks = 0